import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.78);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100000;
  animation: ${fadeIn} 160ms ease-out;
  backdrop-filter: blur(4px);
`;

export const Card = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 32px 40px;
  min-width: 320px;
  max-width: min(420px, calc(100vw - 32px));
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);
`;

export const Spinner = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 3px solid #e5e7eb;
  border-top-color: #2d5bff;
  animation: ${spin} 0.8s linear infinite;
  margin-bottom: 20px;
`;

export const Title = styled.h3`
  font-family: Inter;
  font-size: 18px;
  font-weight: 600;
  color: #111827;
  margin: 0 0 8px 0;
`;

export const Description = styled.p`
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  color: #4b5563;
  line-height: 1.5;
  margin: 0;
`;
